<template>
    <JqxWindow ref="myWindow" :theme="'material'" :width="1900" :height="600" :resizable="true" :isModal="true"
               :autoOpen="false">
        <div class="col-md"><strong>Check</strong>
        </div>
        <div>
            <input type="hidden" @click="clickCheck" id="hiddencheck" />
            <div style="height: 80%">
                <JqxDetailsCheck ref="DetailsCheck"></JqxDetailsCheck>
            </div>
            <card>
                <div class="float-right">
                    <JqxButton :theme="'material'" @click="cancelParent">
                        Cancel
                    </JqxButton>
                </div>
            </card>
        </div>
    </JqxWindow>
</template>
<script>
    import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
    import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
    import JqxDetailsCheck from "./JqxDetailsCheck";

    export default {
        name: "ArchivioSpedizioniDetails",
        components: {
            JqxButton,
            JqxWindow,
            JqxDetailsCheck,
        },
        data: function () {
            return {}
        },
        methods: {
            cancelParent() {
                this.$parent.cancelBtn();
            },
            clickCheck() {
                this.$parent.detailsCheck();
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/cruddetails/ArchivioSpedizioniDetails.vue